import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  /** Fires on click or focus. Used when the field only opens the search screen. */
  onActivate?: () => void;
  readOnly?: boolean;
  autoFocus?: boolean;
}
export function SearchField({
  value,
  onChange,
  onActivate,
  readOnly = false,
  autoFocus = false
}: SearchFieldProps) {
  const {
    t
  } = useLocale();
  return <div className="relative" data-id="element-1183" data-mp="pz1tu65uat3e">
      <SearchIcon size={17} className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 text-muted" aria-hidden="true" data-id="element-1184" data-mp="pytf08q5pdpk" />
      <input type="search" value={value} readOnly={readOnly} autoFocus={autoFocus} onFocus={onActivate} onClick={onActivate} onChange={event => onChange(event.target.value)} placeholder={t('search.placeholder')} aria-label={t('search.placeholder')} className="h-11 w-full rounded-pill border border-sand-line bg-white/80 pl-6 pr-6 text-[13.5px] text-deep placeholder:text-muted focus:border-deep/40" data-id="element-1185" data-mp="h07qzy1x16he" />
      {value.length > 0 && !readOnly && <button type="button" onClick={() => onChange('')} aria-label={t('search.clear')} className="absolute right-1 top-1/2 grid h-9 w-9 -translate-y-1/2 place-items-center rounded-pill text-muted transition-colors duration-150 ease-brand hover:text-deep" data-id="element-1186" data-mp="3plxt6j4uzbl9">
          <XIcon size={15} data-id="element-1187" data-mp="r0ef6et6oesn" />
        </button>}
    </div>;
}